module.exports = __webpack_public_path__ + "static/img/console_order_list.108555f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/console_order_list.png
// module id = wTDy
// module chunks = 8